import { render, staticRenderFns } from "./DocumentosConformidadeTecnica.vue?vue&type=template&id=c7021c06"
import script from "./DocumentosConformidadeTecnica.vue?vue&type=script&lang=js"
export * from "./DocumentosConformidadeTecnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports